import React from "react";
import "../../Styles/Feefrequency.css";

export default function VehicleIncidentDetail1() {
  return (
    <div className="fee-container">
      <div className="special-header panel-white-all">
        <h4 className="page-title">Vehicle Incident Details</h4>
      </div>

      <div className="ff-page-body">
        <div className="card ff-detail-card">
          <div className="card-body">
            <div className="table-responsive">
              <table className="table ff-detail-table mb-0">
                <tbody>
                  <tr>
                    <td className="fw-bold ff-detail-label">Vehicle Name</td>
                    <td>Test Vehicle</td>
                  </tr>
                  <tr>
                    <td className="fw-bold ff-detail-label">Driver</td>
                    <td>Super Fast</td>
                  </tr>
                  <tr>
                    <td className="fw-bold ff-detail-label">Location</td>
                    <td>Pune</td>
                  </tr>
                  <tr>
                    <td className="fw-bold ff-detail-label">Description</td>
                    <td>Trip</td>
                  </tr>
                  <tr>
                    <td className="fw-bold ff-detail-label">Expense</td>
                    <td>$2000</td>
                  </tr>
                  <tr>
                    <td className="fw-bold ff-detail-label">Date</td>
                    <td>Mon Jul 8 2023</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
